import type { FaireProductEntity } from "../../entity_types/product";

export const p_bcme6qq7x7: FaireProductEntity = {
  token: "p_bcme6qq7x7",
  type: "product",
  name: "* KIDS * Cowgirl Beach Club Kids Boxy T-Shirt",
  brandToken: "b_jbqutfkjxx",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9d2025c88b1a38caaf090026010230619b10aabb5a3a8aa1e0f52609ed686f68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/544c0962cddf13077d77fa91ad9e887b615bc629308621dce64a3ad07792dc48.jpeg",
    "https://cdn.faire.com/fastly/b0fc1ceccabce7ca56b0446fef756f99176a9a48af6d237fef163a1c5585531b.jpeg",
    "https://cdn.faire.com/fastly/795234d83c77bb9678d4a7af57160aa61749a79f2c4387153dcefd29d4e880ca.jpeg",
    "https://cdn.faire.com/fastly/4c16a51fb42e33acb3f27ba61f2e96be3fdc2c3615e358c10397105a19b715f6.jpeg",
    "https://cdn.faire.com/fastly/e8d4b8c5fd0c32ed50b73a00362fe0d4d9a2b689bad79bb78d2cb0b49ac804b7.jpeg",
    "https://cdn.faire.com/fastly/d44bd8dec6c42e8907ea82fc5992654758c5bb572b74718bd2d922f1f584473f.jpeg",
    "https://cdn.faire.com/fastly/6dbb1563ece25bd22bd791c51f1d8447a338da3a03f8961f87f89033200f7dc8.jpeg",
    "https://cdn.faire.com/fastly/39a5beb9f4c4d01154d06c9190d990ee32a6f9a5ca83e0a60d9610a70ca70e51.jpeg",
    "https://cdn.faire.com/fastly/21e1e44889cbc6d5bc49c8f31220d00a484bdd15a570b1f39653d083376f2af2.png",
    "https://cdn.faire.com/fastly/f53259ab795408d6aef2c678fdc779dac1514a0bb6f0113701343371cd5c8433.png",
    "https://cdn.faire.com/fastly/f606e68260c7782dcd9843909bfa28cfeb4302acf955a6a15a42d998cd5f8305.png",
  ],
  priceDollars: 20.79,
  description:
    '* MADE IN USA. 6.5 OZ. 100% COTTON. *\n\nGet all of the Beachy vibes in our *NEW* Kids Boxy Cowgirl Beach Club inspired tshirt!\n\n- Features "The one & only Cowgirl Beach Club" with a beach club and cowgirl illustration and  " All cowgirls are welcome " in a navy ink\n\n- Screen print transfer that is heat pressed onto each tshirt\n\n- Tshirt is a super soft vintage wash that gets softer after each wash, features drop shoulder and a double stitch collar\n\n- Meant to be a Boxy fit\n\n- Refer to photos for size references on how the tees fit -- Model in Ivory is typically a size 2T wearing a size 4/5 for an oversized look | Model in Ivory & Blue Jean is typically a size 10 wearing a size 12 for an oversized look\n\n- 100% Cotton\n\n* due to screens and filters colors may vary slightly to photos - colors on mock up most closely represent the color of the actual item as our product photos have filters that can affect the colors / lighting *',
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:15.148Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
